import { useQuery } from "@apollo/client";
import { GET_LATEST_SYNC_RESULT_QUERY } from "../../../apis/salesforce/queries";
import { HG_FORCE_CLIENT } from "../../../utils/consts";
import {
  GetLatestSyncResultResponse,
  GetLatestSyncResultVariables,
} from "../types";

export interface UseLatestSyncResultOptions {
  skip?: boolean;
  pollInterval?: number;
  fetchPolicy?:
    | "cache-first"
    | "cache-and-network"
    | "network-only"
    | "cache-only"
    | "standby";
}

export const useLatestSyncResult = (
  integrationId?: string,
  options: UseLatestSyncResultOptions = {}
) => {
  const { skip = false, pollInterval, fetchPolicy = "cache-first" } = options;

  const result = useQuery<
    GetLatestSyncResultResponse,
    GetLatestSyncResultVariables
  >(GET_LATEST_SYNC_RESULT_QUERY, {
    variables: { integrationId },
    context: { clientName: HG_FORCE_CLIENT },
    skip: skip || !integrationId,
    pollInterval,
    fetchPolicy,
    errorPolicy: "all",
  });

  return {
    ...result,
    syncResult: result.data?.latestSyncResult,
  };
};
